import { MenuService } from '@/layout/service/menu.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';
import { PessoaService } from '@/shared/services/pessoa.service';

@Component({
    selector: 'app-gestao-comissoes-content',
    standalone: true,
    imports: [RouterModule, Pesquisa],
    template: `<router-outlet></router-outlet>
        <app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="carregarPessoa($event)"></app-pesquisa> `
})
export class GestaoComissoesContent implements OnInit {
    pesquisarDialog: boolean = false;

    rootPath = 'gestao-comissoes';
    menu = [
        {
            label: 'Gestão de Comissões',
            expanded: true,
            items: [
                {
                    label: 'Dashboard',
                    icon: 'pi pi-fw pi-chart-bar',
                    expanded: true,
                    items: [
                        {
                            label: 'Reuniões',
                            icon: 'pi pi-fw pi-calendar',
                            expanded: true,
                            items: [
                                { label: 'Visão geral', icon: 'pi pi-fw pi-chart-line', routerLink: [this.rootPath, 'dashboard', 'reunioes', 'visao-geral'], data: { breadcrumb: 'Visão geral' } },
                                { label: 'Distribuição', icon: 'pi pi-fw pi-chart-pie', routerLink: [this.rootPath, 'dashboard', 'reunioes', 'distribuicao'], data: { breadcrumb: 'Distribuição' } },
                                { label: 'Operação', icon: 'pi pi-fw pi-map-marker', routerLink: [this.rootPath, 'dashboard', 'reunioes', 'operacao'], data: { breadcrumb: 'Operação' } }
                            ]
                        },
                        {
                            label: 'Atas',
                            icon: 'pi pi-fw pi-file-edit',
                            expanded: true,
                            items: [
                                { label: 'Visão geral', icon: 'pi pi-fw pi-chart-line', routerLink: [this.rootPath, 'dashboard', 'atas', 'visao-geral'], data: { breadcrumb: 'Visão geral' } },
                                { label: 'Qualidade', icon: 'pi pi-fw pi-flag', routerLink: [this.rootPath, 'dashboard', 'atas', 'qualidade'], data: { breadcrumb: 'Qualidade' } }
                            ]
                        },
                        {
                            label: 'Convocações',
                            icon: 'pi pi-fw pi-send',
                            expanded: true,
                            items: [
                                { label: 'Confirmação', icon: 'pi pi-fw pi-check-circle', routerLink: [this.rootPath, 'dashboard', 'convocacoes', 'confirmacao'], data: { breadcrumb: 'Confirmação' } },
                                { label: 'Presença e atos', icon: 'pi pi-fw pi-ticket', routerLink: [this.rootPath, 'dashboard', 'convocacoes', 'presenca-atos'], data: { breadcrumb: 'Presença e atos' } }
                            ]
                        },
                        {
                            label: 'Atividades',
                            icon: 'pi pi-fw pi-briefcase',
                            expanded: true,
                            items: [
                                { label: 'Visão geral', icon: 'pi pi-fw pi-chart-line', routerLink: [this.rootPath, 'dashboard', 'atividades', 'visao-geral'], data: { breadcrumb: 'Visão geral' } },
                                { label: 'Distribuição', icon: 'pi pi-fw pi-users', routerLink: [this.rootPath, 'dashboard', 'atividades', 'distribuicao'], data: { breadcrumb: 'Distribuição' } }
                            ]
                        },
                        {
                            label: 'Membros',
                            icon: 'pi pi-fw pi-users',
                            expanded: true,
                            items: [
                                { label: 'Composição', icon: 'pi pi-fw pi-map', routerLink: [this.rootPath, 'dashboard', 'membros', 'composicao'], data: { breadcrumb: 'Composição' } },
                                { label: 'Conformidade', icon: 'pi pi-fw pi-shield', routerLink: [this.rootPath, 'dashboard', 'membros', 'conformidade'], data: { breadcrumb: 'Conformidade' } }
                            ]
                        },
                        {
                            label: 'Comissões',
                            icon: 'pi pi-fw pi-sitemap',
                            expanded: true,
                            items: [
                                { label: 'Perfil', icon: 'pi pi-fw pi-sitemap', routerLink: [this.rootPath, 'dashboard', 'comissoes', 'perfil'], data: { breadcrumb: 'Perfil' } },
                                { label: 'Situação', icon: 'pi pi-fw pi-power-off', routerLink: [this.rootPath, 'dashboard', 'comissoes', 'situacao'], data: { breadcrumb: 'Situação' } },
                                { label: 'Agenda futura', icon: 'pi pi-fw pi-calendar-times', routerLink: [this.rootPath, 'dashboard', 'comissoes', 'agenda-futura'], data: { breadcrumb: 'Agenda futura' } }
                            ]
                        },
                        {
                            label: 'Conselheiros',
                            icon: 'pi pi-fw pi-id-card',
                            expanded: true,
                            items: [{ label: 'Atuação', icon: 'pi pi-fw pi-chart-bar', routerLink: [this.rootPath, 'dashboard', 'conselheiros', 'atuacao'], data: { breadcrumb: 'Atuação' } }]
                        }
                    ]
                },
                {
                    label: 'Produção',
                    icon: 'pi pi-fw pi-star',
                    expanded: true,
                    items: [
                        { label: 'Assistente', icon: 'pi pi-fw pi-user', routerLink: [this.rootPath, 'producao'], data: { breadcrumb: 'Assistente' } },
                        { label: 'Coordenação', icon: 'pi pi-fw pi-id-card', routerLink: [this.rootPath, 'coordenacao'], data: { breadcrumb: 'Coordenação' } },
                        { label: 'Secretaria', icon: 'pi pi-fw pi-pencil', routerLink: [this.rootPath, 'secretaria'], data: { breadcrumb: 'Secretaria' } },
                        {
                            label: 'Conselheiros',
                            icon: 'pi pi-fw pi-id-card',
                            expanded: true,
                            items: [
                                {
                                    label: 'Regionais',
                                    icon: 'pi pi-fw pi-map-marker',
                                    expanded: true,
                                    items: [
                                        { label: 'Maior presença', icon: 'pi pi-fw pi-star', routerLink: [this.rootPath, 'ranking-conselheiros', 'regionais', 'presenca'], data: { breadcrumb: 'Maior presença' } },
                                        { label: 'Maior nº de comissões', icon: 'pi pi-fw pi-sitemap', routerLink: [this.rootPath, 'ranking-conselheiros', 'regionais', 'comissoes'], data: { breadcrumb: 'Maior nº de comissões' } },
                                        { label: '% de comparecimento', icon: 'pi pi-fw pi-percentage', routerLink: [this.rootPath, 'ranking-conselheiros', 'regionais', 'comparecimento'], data: { breadcrumb: '% de comparecimento' } }
                                    ]
                                },
                                {
                                    label: 'Federais',
                                    icon: 'pi pi-fw pi-flag',
                                    expanded: true,
                                    items: [
                                        { label: 'Maior presença', icon: 'pi pi-fw pi-star', routerLink: [this.rootPath, 'ranking-conselheiros', 'federais', 'presenca'], data: { breadcrumb: 'Maior presença' } },
                                        { label: 'Maior nº de comissões', icon: 'pi pi-fw pi-sitemap', routerLink: [this.rootPath, 'ranking-conselheiros', 'federais', 'comissoes'], data: { breadcrumb: 'Maior nº de comissões' } },
                                        { label: '% de comparecimento', icon: 'pi pi-fw pi-percentage', routerLink: [this.rootPath, 'ranking-conselheiros', 'federais', 'comparecimento'], data: { breadcrumb: '% de comparecimento' } }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    label: 'Frequência',
                    icon: 'pi pi-fw pi-table',
                    routerLink: [this.rootPath, 'frequencia-comissoes'],
                    data: { breadcrumb: 'Frequência de Comissões' }
                },
                {
                    label: 'Pesquisar Pessoa',
                    icon: 'pi pi-fw pi-search',
                    command: () => {
                        this.pesquisarDialog = true;
                    }
                }
            ]
        }
    ];

    constructor(
        private menuService: MenuService,
        private router: Router,
        private pessoaService: PessoaService
    ) {}

    ngOnInit(): void {
        // Envia os itens de menu para o serviço
        this.menuService.setMenu(this.menu);
        // Sem isto o topbar mantinha o nome do módulo anterior — este é o módulo de gestão,
        // não o operacional de Comissões e Câmaras Técnicas.
        this.menuService.setSistema('SICOM | Gestão de Comissões');
    }

    private async executar(rota: string) {
        // 1. Navega para uma rota "falsa" ou para a raiz do app.
        // 'skipLocationChange: true' faz isso sem mudar a URL na barra de endereço do navegador.
        await this.router.navigateByUrl('/', { skipLocationChange: true });

        // 2. Agora, navega de volta para a rota original.
        // Como não estamos mais na mesma rota, o Angular irá recriar o componente.
        await this.router.navigate([rota]);
    }

    carregarPessoa(pessoa?: Pessoa) {
        // 1. O objeto 'pessoa' existe?

        if (pessoa) {
            this.pessoaService.setPessoa(pessoa);

            if (this.rootPath) {
                this.executar(this.rootPath + '/pessoa');
            } else {
                console.error('A variável this.rootPath está vazia ou indefinida!');
            }
        } else {
            // Se esta mensagem aparecer, o problema é que 'pessoa' é nulo ou indefinido.
            console.error('Registro não encontrado!');
        }
    }
}
